import React, { useEffect, useRef, useState } from 'react';
//import { loadThreads } from '../utils/botFactoryAPI';
import { buildContactEmail, contactEmailFailureText, pickAgentId } from '../utils/contactEmail';
import './ChatUIMin.scss';
import { WavRecorder, WavStreamPlayer } from '../lib/wavtools/index.js';
import { WavRenderer } from '../utils/wav_renderer';
import { StarFormation } from './star/StarFormation';


// ⛔ REACT_APP_-prefixed or it is dead: CRA inlines nothing else. `EMAIL_BASE_URL` was
// never reaching the bundle, so v2 has been emailing through the LEGACY api all along —
// silent, because a working legacy endpoint looks exactly like success.
const EMAIL_BASE_URL =
  process.env.REACT_APP_EMAIL_BASE_URL ||
  'https://robot-api-37f87b97b291.herokuapp.com';

const PAGE_TIMEOUT = 900;
const PROMPT_BUTTON_MAX = 9;
const THREAD_LIMIT = 5;

// Get user
const storedUser = localStorage.getItem("user");
const user = storedUser && storedUser !== "null" ? JSON.parse(storedUser) : {
  id: "guest",
  username: "guest",
  email: "",
  firstname: "Guest",
  lastname: "User",
  emailVerified: false,
  verificationToken: "",
  role: "guest",
  mobile: "",
  pic: "",
  system: false,
};

// Get org settings from cookie
let settings = null;
try {
  const orgCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('org='))
    ?.split('=')[1];

  if (orgCookie) {
    settings = JSON.parse(decodeURIComponent(orgCookie));
  }
} catch (err) {
  console.warn('❌ Failed to parse settings from org cookie:', err);
}

const ChatUIMin = ({
  Header,
  Footer,
  iBots,
  assistantId,
  isConnected,
  timeLeft,
  connectConversation,
  setTimeLeft,
  sendTextQuery,
  isRecording,
  startRecording,
  stopRecording,
  clientCanvasRef,
  serverCanvasRef,
  items,
  setItems,
  clientRef,
  iBookThumbnail,
  showEventsLog,
  setShowEventsLog,
  eventsScrollRef,
  realtimeEvents,
  botSettings = null,
  selectedBot,
  clearSession,
  toggleMute = () => {},
  isMuted = false,
  audioData = { user: [], assistant: [] },
  emitStandbyLine = () => {},
  onPromptClicked = (_prompt) => {},
  onUserQuestion = (_message) => {},
  onSessionCleared = (_reason) => {},
  onLanguageCommand = (_lang) => {},
}) => {
  const userInputRef = useRef(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailTo, setEmailTo] = useState("");
  const [emailSubject, setEmailSubject] = useState("Conversation Content");
  const [emailBody, setEmailBody] = useState("");
  const [emailFrom, setEmailFrom] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [emailFromName, setEmailFromName] = useState("");
  const [emailToName, setEmailToName] = useState("");
  const [isConversationExpanded, setIsConversationExpanded] = useState(false);

  //const [threads, setThreads] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  //const [threadOffset, setThreadOffset] = useState(0);
  const [conversation, setConversation] = useState([]);
  const notifySessionCleared = (reason = 'user_stop') => {
    if (typeof onSessionCleared === 'function' && onSessionCleared !== clearSession) {
      onSessionCleared(reason);
    }
  };
  //const [run, setRun] = useState(null);
  //const [thread, setThread] = useState(null);

  const videoContainerRef = useRef(null);

  const [currentSpeaker, setCurrentSpeaker] = useState('user'); // or 'assistant'
  const morphCanvasRef = useRef(null);

  /*const handleLoadThreads = async () => {
    setLoading(true);
    setError(null);
    const user = JSON.parse(localStorage.getItem("user"));

    const token = document.cookie
              .split('; ')
              .find(row => row.startsWith('token='))
              ?.split('=')[1];
    console.log('Token:', token);

    if (!token && user) {
      setError("[handleLoadThreads] - ChatUIWhite -User /u token missing - auth token not found.");
      setLoading(false);
      return;
    }
    try {
      const data = await loadThreads(user.id, token, offset, THREAD_LIMIT);
      setThreads(data);
      setThreadOffset(offset);
    } catch (err) {
      setError(err.message);
    } finally {
    setLoading(false);
  }
};*/

  const handleEmailCloseModal = () => {
    setShowEmailModal(false);
  };

  const copyConversationContent = () => {
    const conversationElement = document.getElementById('conversation');
    if (conversationElement) {
      const content = conversationElement.innerHTML;
      console.log('Copying content:', content);

      const textToCopy = conversationElement.innerText || ''; 
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          alert('Conversation copied to clipboard!');
        })
        .catch((error) => {
          console.error('Failed to copy content to clipboard:', error);
        });
    } else {
      console.error('Conversation element not found!');
    }
  };

  const openEmailModal = () => {
    const conversationElement = document.getElementById('conversation');
    if (!conversationElement || !conversationElement.innerText.trim()) {
      try {
        sessionStorage.setItem('metricsHold', '1');
        setTimeout(() => sessionStorage.removeItem('metricsHold'), 5000);
      } catch (err) {
        // ignore
      }
      alert("Conversation is empty. Cannot send an empty email.");
      return;
    }

    setEmailErrorMessage("");

    console.log("🔍 Debug: Checking User Email Before Escaping:",emailFrom);
    const escapedEmail = emailFrom.replace(/[^\w\s@.]/g, '');
    setEmailFrom(escapedEmail);
    console.log("✅ Debug: Escaped Email:", escapedEmail);

    setEmailBody(conversationElement.innerText || "");
    setEmailTo("");
    const timestamp = new Date().toLocaleString();

    setEmailSubject(`${selectedBot.title} - Conversation with ${emailFromName}  - ${timestamp}`);

    console.log("✅  Email Modal Opened, showEmailModal:", showEmailModal);
    setShowEmailModal(true);
  };

  const sendEmailContent = async () => {
    const emailFromName = document.getElementById('emailFromName').value;
    const emailFrom = document.getElementById('emailFrom').value;

    const emailSubject = document.getElementById('emailSubject').value;
    const emailBody= document.getElementById('email-textarea').value;

    if (!emailFromName.trim()) {
      alert("Please enter your name.");
      return;
    }
    if (!emailSubject.trim()) {
      alert("Please enter a subject.");
      return;
    }
    if (!emailBody.trim()) {
      alert("Email body cannot be empty.");
      return;
    }
    // v2.07: botapi picks the recipient and sender from the bot's settings, so the request carries
    // only these plain-text fields (anything else is a 422). See utils/contactEmail.js.
    const built = buildContactEmail({
      agentId: pickAgentId(selectedBot?.agentId, selectedBot?.id, selectedBot?.botid, assistantId),
      visitorName: emailFromName,
      visitorEmail: emailFrom,
      subject: emailSubject,
      message: emailBody,
    });
    if (!built.ok) {
      alert(built.error);
      return;
    }
    const emailData = built.payload;

    console.log("📩 Sending Email Data:", emailData);

    try {
      const response = await fetch(EMAIL_BASE_URL +"/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(emailData),
      });

      if (response.ok) {
        alert("✅ - Email sent successfully!");
        handleEmailCloseModal();
      } else {
        alert(contactEmailFailureText(response.status) || "Failed to send email.");
      }
    } catch (error) {
      console.error("❌ - Error sending email:", error);
      alert("An error occurred while sending the email.");
    }
  };

  const handleStopClick = async () => {
    const client = clientRef?.current;
    if (!client) {
      console.warn('[STOP] clientRef not ready');
      return;
    }

    try {
      if (!client.isConnected()) {
        console.warn('[STOP] WebSocket not connected. Attempting reconnect...');
        await client.connect();
        console.log('[STOP] ✅ Reconnected before sending standby command.');
      }

      if (typeof client.cancelResponse === 'function') {
        try {
          client.cancelResponse('');
        } catch (cancelErr) {
          console.warn('[STOP] cancelResponse failed:', cancelErr);
        }
      }

      emitStandbyLine();
      console.log('✅ [STOP] Standby dispatcher invoked.');

      if (typeof clearSession === 'function') {
        await clearSession();
      }

      notifySessionCleared('user_stop');
    } catch (err) {
      console.warn('❌ [STOP] Failed to run standby flow:', err.message);
    }
  };

  const formatLinks = (text) => {
    if (!text) return '';
    return text.replace(/(https?:\/\/\[\w.-]+(?:\/[\w.-]*)*\/?)\b/g, '<a href="$1" target="_blank">$1</a>');
  };

  // message:   the text shown in the UI / input field (translated in non-English mode).
  // aiMessage: the original English canonical key — used so the model can reliably
  //            match canonical topics and fire media tags.
  //
  // effectiveBot._currentLanguage is set by IndexPageGuest.tsx to reflect the active mode.
  const handleCardActivate = (message, aiMessage) => {
    const isNonEnglish = selectedBot?._currentLanguage && selectedBot._currentLanguage !== 'English';
    const displayText = (message || '').toString().trim();
    const originalText = (aiMessage || message || '').toString().trim();

    onPromptClicked?.(displayText);

    // In non-English mode, send translated text for UI display but English for the AI.
    // IndexPageGuest's sendTextQuery handles this split if two arguments are provided.
    if (isNonEnglish) {
      sendTextQuery(displayText, originalText);
    } else {
      sendTextQuery(originalText);
    }

    onUserQuestion?.(originalText, { fromPrompt: true });
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          console.log("⏱️ Session expired due to inactivity. Click OK to Reload.");
          window.location.reload();
          return 0;
        }
        return prev - 1;
      });
    }, 10000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (userInputRef.current) {
      userInputRef.current.focus();
    }
  }, []);

  /* Visualization */
  useEffect(() => {
    const initAudio = async () => {
      try {
        await wavRecorderRef.current.begin();
        await wavStreamPlayerRef.current.connect();
        console.log('[Audio Init] ✅ Recorder and Player ready');
      } catch (err) {
        console.error('[Audio Init] ❌ Failed to init audio devices:', err);
      }
    };
    initAudio();

    return () => {
      wavRecorderRef.current.end?.();
      wavStreamPlayerRef.current.interrupt?.();
      console.log('[Audio Teardown] 🛑 Stopped recorder and player');
    };
  }, []);


  useEffect(() => {
    const canvas = morphCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const pixelRatio = window.devicePixelRatio || 1;
    const width = 150;
    const height = 150;

    canvas.width = width * pixelRatio;
    canvas.height = height * pixelRatio;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    ctx.scale(pixelRatio, pixelRatio);

    let t = 0;
    let frameId;

    const draw = () => {
      t += 0.02;

      let amplitude = 0.2;
      if (currentSpeaker === 'user') {
        const voice = WavRecorder.current?.getFrequencies?.('voice');
        amplitude = voice?.values?.[0] || 0.2;
      } else {
        const voice = wavStreamPlayerRef.current?.getFrequencies?.('voice');
        amplitude = voice?.values?.[0] || 0.2;
      }

      const green = Math.floor(64 + 192 * amplitude);
      const purple = Math.floor(64 + 192 * (1 - amplitude));
      const color = currentSpeaker === 'user'
        ? `rgb(${green}, 0, 128)`
        : `rgb(128, 0, ${purple})`;


      ctx.clearRect(0, 0, width, height);
      const gradient = ctx.createRadialGradient(75, 75, 20, 75, 75, 75);
      gradient.addColorStop(0, color);
      gradient.addColorStop(1, '#000');

      ctx.fillStyle = gradient;
      ctx.beginPath();

      const radius = 65 + 15 * amplitude;// real voice activity
      ctx.arc(75, 75, radius, 0, Math.PI * 2);

      ctx.fill();

      frameId = requestAnimationFrame(draw);
    };

    draw();

    return () => cancelAnimationFrame(frameId);
  }, []);

  useEffect(() => {
    if (!items?.length) return;

    const lastItem = items[items.length - 1];
    if (lastItem?.role === 'assistant') {
      setCurrentSpeaker('assistant');
    } else if (lastItem?.role === 'user') {
      setCurrentSpeaker('user');
    }
  }, [items]);

  // Cleanup effect
  useEffect(() => {
    return () => {
      // Cleanup any resources if needed
    };
  }, []);

  return (
    <div className="chat-ui-wrapper">
      {/* Top bar */}
      <div className="chat-ui-topbar">
      </div>

      {/* Middle section with black circle */}
      {/*<div className="chat-ui-center">
        <div className="chat-ui-circle">
          <canvas
            ref={morphCanvasRef}
            width="150"
            height="150"
            style={{ width: '150px', height: '150px', borderRadius: '50%' }}
          />
        </div>
      </div>
      */}

      {/* visualization begin */}
      <div className="chat-ui-center">
        <div id="content-visuals" className="content-visuals">
                <div className="visualization-container">
                    {/* Client Sound Wave Canvas */}
                    <canvas id="client-sound-wave" ref={clientCanvasRef} className="sound-wave"></canvas>
                    <div id="video-container" className="video-container">
                        {/* <video autoPlay muted loop id="circle-video">
                            <source src="/vecteezy_deep-space-background-loop_1806797.mp4" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                      <img src="vecteezy_deep-space-green.gif" alt="Agent"></img>*/}
                      <StarFormation videoContainerRef={videoContainerRef} />
                    </div>

                    {/* Server Sound Wave Canvas */}
                    <canvas id="server-sound-wave" ref={serverCanvasRef} className="sound-wave"></canvas>
                </div>
            </div>
          </div>


      {/* visualization end */}

      {/* Messages */}
      <div className="chat-ui-messages">
        <button className="chat-toggle-btn" onClick={() => setIsConversationExpanded(!isConversationExpanded)}>
          {isConversationExpanded ? '↑' : '↓'}
        </button>
        <div id="conversation" className={`chat-ui-conversation ${isConversationExpanded ? 'expanded' : ''}`}>
          {isConversationExpanded && items
            .filter((item) => {
              const text = item.formatted?.text?.trim().toLowerCase();
              const isPing = text === '...';
              const isDot = text === '.';
              const isStandbyAssistantMessage =
                item.role === 'assistant' &&
                (
                  text.includes('standing by') ||
                  text.includes("let me know when you're ready") ||
                  text.includes("we can continue whenever you're") ||
                  text.includes("take your time, i'm right here") ||
                  text.includes('great to see you') ||
                  text.includes("here whenever you're ready to continue.") ||
                  text.includes("i'm still here") ||
                  text.includes('just a reminder')
                );

              return !isPing && !isDot && !isStandbyAssistantMessage;
            })
            .map((item, index) => {
              const rawText = item.formatted?.text || item.formatted?.transcript || '';
              const formattedText = formatLinks(rawText);

              const botName = selectedBot?.name ? `${selectedBot.name}: ` : "Agent";
              let userName = "User";
              if (user) {
                userName = user?.firstname
                  ? `${user.firstname[0].toUpperCase()}${user.firstname.slice(1)}: `
                  : "User: ";
              }

              const prefix = item.role === 'assistant'
                ? botName
                : item.role === 'user'
                ? userName
                : '';

              return (
                <div key={`message-${index}`} className={`chat-msg ${item.role}`}>
                  <div className="chat-message-header">
                    <strong>{prefix}</strong>
                  </div>
                  <div className="chat-message-content">
                    {formattedText}
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      {/* Input area */}
      <div className="chat-ui-input-wrapper">
        <div className="chat-ui-input-container">
          <div className="chat-ui-buttons-left">
            <button
              className={`chat-ui-button mic ${isRecording ? 'recording' : ''}`}
              onClick={() => {
                if (isRecording) {
                  stopRecording();
                } else {
                  startRecording();
                }
              }}
            >
              <i className={`fas ${isRecording ? 'fa-stop' : 'fa-microphone'}`} />
            </button>

            <button
              className="chat-ui-button cancel"
              title="Stop assistant and recording"
              onClick={() => {
                stopRecording();
                handleStopClick();
              }}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );  
  
};

ChatUIMin.defaultProps = {
  botSettings: null,
  toggleMute: () => {},
  isMuted: false,
};

export default ChatUIMin;
